import { getAxiosInstance } from '../../react/utils/networkUtil';
import { S2Mosaic_Base } from '../models/S2Mosaic';

export enum S2MosaicType {
  Day = 'day',
  Month = 'month',
  Year = 'year',
}
export const S2MosaicTypeModelUtil = {
  getDescription: (type: S2MosaicType) => {
    switch (type) {
      case S2MosaicType.Day:
        return 'Ghép theo khoảng ngày';
      case S2MosaicType.Month:
        return 'Ghép theo tháng';
      case S2MosaicType.Year:
        return 'Ghép theo năm';
    }
  },
};

// #region get page
export type S2Mosaic_GetPage_Request = {
  type: S2MosaicType;
  year?: number;
  month?: number;
  start_date?: string;
  end_date?: string;
  point?: any;
  point_lat?: number;
  point_lon?: number;
};
export type S2Mosaic_GetPage_ResponseItem = {
  bbox: any;
  id: string;
  imageDescription: any;
  thumbUrl: string;
  wmsUrl: string;
};

export const remote_GetPage = async (request: S2Mosaic_GetPage_Request): Promise<S2Mosaic_GetPage_ResponseItem[]> => {
  const params: any = { ...request };
  if (request.point?.coordinates && Array.isArray(request.point.coordinates)) {
    params.point_lon = request.point.coordinates[0];
    params.point_lat = request.point.coordinates[1];
    delete params.point;
  }
  return (
    await getAxiosInstance().get('/api/remote-image-alert-ext/sentinel-2-mosaic/getPage', {
      params,
    })
  ).data;
};

export const remote_RefreshWMS = async (id: number): Promise<any> => {
  return (await getAxiosInstance().post(`/api/remote-image-alert-ext/sentinel-2-mosaic/${id}/refresh`)).data;
};

// #endregion: remote_GetPage

export const S2MosaicAPIs = {
  remote_GetPage,
  remote_RefreshWMS,
};
